import React, { useState, useEffect, useRef } from 'react';
import useWindowDimensions from '../hooks/useWindowDimension';
import { checkIsOverflowed } from '../hooks/useOverflowed';
import { Tooltip } from './Tooltip';

const findUsedItemInList = (listOfItems, itemId) => {
    return listOfItems.find(it => it.itemId === itemId);
};

const SelectWithTokensSelectListItem = ({ selectItem, selectWithTokensManager }) => {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const ref = useRef();
    const width = useWindowDimensions();
    
    useEffect(() => {
        setIsOverflowed(checkIsOverflowed(ref.current));
    }, [width]);

    const selectListItem = (e) => {
        e.stopPropagation();
        e.preventDefault();
        selectWithTokensManager.addItem(selectItem.itemId, selectItem.included);
    };

    const isSelected = Boolean(
        findUsedItemInList(selectWithTokensManager.getCurrentItems(), selectItem.itemId),
    );

    return (
        <Tooltip content={selectItem.itemTitle} enabled={isOverflowed}>
            <li key={selectItem.itemId + 'selected' + selectItem.itemId}
                className={`block__content product__forms-option 
                    ${isSelected ? 'product__forms-option_active' : ''}`}
                onClick={(e) => isSelected ? null : selectListItem(e)}>
                <span className="product__forms-content" ref={ref}>{selectItem.itemTitle}</span>
            </li>
        </Tooltip>
    );
};

export default SelectWithTokensSelectListItem;
